import * as THREE from 'three';
import { RoomEnvironment } from 'three/examples/jsm/environments/RoomEnvironment.js';

/**
 * HDR-style IBL for PBR cars / glass — call once after the WebGLRenderer exists.
 */
export function createSceneEnvironment(
  renderer: THREE.WebGLRenderer,
): THREE.Texture {
  const pmrem = new THREE.PMREMGenerator(renderer);
  pmrem.compileEquirectangularShader();
  const env = new RoomEnvironment();
  const rt = pmrem.fromScene(env, 0.022);
  pmrem.dispose();
  return rt.texture;
}
